"use client";

import {
  type CarouselItemType,
  OnboardingCarousel,
} from "../components/onboarding-carousel";
import { TrustedLogos } from "../components/trusted-logos";

const carouselItems: CarouselItemType[] = [
  {
    id: 1,
    quote:
      "Jurni enabled us to scale our funnel strategy quickly and effectively. We built multiple variations for different use cases and continuously iterated through experiments to compare performance across ad campaigns. Today, Jurni is a core part of our growth marketing efforts.",
    quoter: {
      image: "/images/onboarding/cody-plofker.jpeg",
      fullName: "Cody Plofker",
      title: "CEO, Jones Road Beauty",
    },
  },
  {
    id: 2,
    quote:
      "Jurni allows our teams to scale landing page and funnel experimentation across brands. We can test, iterate, and evolve templates efficiently, supporting continuous optimization while maintaining consistency and control.",
    quoter: {
      image: "/images/onboarding/omer-sher.jpeg",
      fullName: "Omer Sher",
      title: "Chief Growth Officer, P&G Beauty",
    },
  },
  {
    id: 3,
    quote:
      "Jurni helped us scale landing pages while creating localized funnels tailored to different regions and languages. The ability to test and iterate within a single workflow has significantly improved how we approach global growth.",
    quoter: {
      image: "/images/onboarding/danya-klein.jpeg",
      fullName: "Danya Klein",
      title: "Co-CEO, Gensee",
    },
  },
  {
    id: 4,
    quote:
      "Jurni enabled us to scale our funnel strategy quickly and effectively. We built multiple variations for different use cases and continuously iterated through experiments to compare performance across ad campaigns. Today, Jurni is a core part of our growth marketing efforts.",
    quoter: {
      image: "/images/onboarding/cody-plofker.jpeg",
      fullName: "Cody Plofker",
      title: "CEO, Jones Road Beauty",
    },
  },
  {
    id: 5,
    quote:
      "Jurni allows our teams to scale landing page and funnel experimentation across brands. We can test, iterate, and evolve templates efficiently, supporting continuous optimization while maintaining consistency and control.",
    quoter: {
      image: "/images/onboarding/omer-sher.jpeg",
      fullName: "Omer Sher",
      title: "Chief Growth Officer, P&G Beauty",
    },
  },
  {
    id: 6,
    quote:
      "Jurni helped us scale landing pages while creating localized funnels tailored to different regions and languages. The ability to test and iterate within a single workflow has significantly improved how we approach global growth.",
    quoter: {
      image: "/images/onboarding/danya-klein.jpeg",
      fullName: "Danya Klein",
      title: "Co-CEO, Gensee",
    },
  },
];

export default function DefaultRight() {
  return (
    <div className="relative flex h-full w-full flex-col">
      <div className="relative flex h-full w-full items-center justify-center">
        <OnboardingCarousel items={carouselItems} />
      </div>

      <TrustedLogos />
    </div>
  );
}
